export const routes = [
  {
    path: '/analytics',
    name: 'analyticsHome',
    component: () => import('../pages/AnalyticsPage.vue'),
  },
];
